import {
  Box,
  VStack,
  HStack,
  //   Stack,
  Text,
  FormControl,
  // FormHelperText,
  Breadcrumb,
  BreadcrumbItem,
  //   CircularProgress,
  // Badge,
  useDisclosure,
  //   CircularProgress,
  useToast,
  // Checkbox,
  Container,
  Heading,
  Divider,
  IconButton,
  FormHelperText,
  //   Avatar,
} from "@chakra-ui/react";
import { useMemo, useState, useEffect, useRef } from "react";
import { ChevronRightIcon, CopyIcon } from "@chakra-ui/icons";

import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";

// import FCMB from "assets/png/fcmb.png";

import { useHistory, useParams } from "react-router-dom";

import Select from "components/Select/Select";
import Input from "components/Input/Input";
import NumberInput from "components/Input/NumberInput";
import Button from "components/Button/Button";
import ConfirmationModal from "components/Modals/p2p/Confirmation";
import UploadProof from "components/Modals/p2p/UploadProve";
import SuccessModal from "components/Modals/Success";
//   import { RSelect, OptionLabel } from "components/Select/RSelect";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";

import {
  useFundFiatWalletMutation,
  useDepositFundsMutation,
  useCancelFundDepositMutation,
  useProcessPaymentMutation,
  useGetDepositConfigQuery,
} from "services/walletApi";

import { uploadFile } from "util/do";

// import useWallet from "hooks/useWalletBalance";
import useCoinInfo from "hooks/useCoinInfo";
import {
  // appendScript,
  removeScript,
  appendScriptPromise,
} from "hooks/useScript";

import useCopy from "hooks/useCopy";
import formatter from "util/formatter";
import ls from "util/secureStorage";

// import toCoinLocale from "util/toCoinLocale";
import constants from "config/constant";
import getError from "util/getError";
import toCoinLocale from "util/toCoinLocale";

const depositKey = "depo";

const countryMap = (curr) => {
  const mp = {
    ngn: "NG",
    kes: "KE",
    ghs: "GH",
  };

  return mp[String(curr).trim().toLowerCase()] || "";
};

const currencySymbol = (curr) => {
  const map = {
    ngn: "₦",
    ghs: "GH₵",
    kes: "KES",
  };

  return map[curr ?? "ngn"];
};

const BankTransfer = ({ coin, data, fee, min, max, setState, isLowerThanMinimum, setDepositData }) => {
  const { onCopy } = useCopy(data?.depositBankTo?.bankAccountNumber ?? "0123456789");
  const { onCopy: onTxRefCopy } = useCopy(data?.reference ?? "1223DE234");

  const toast = useToast();
  const history = useHistory();

  console.log("deposit data", { data });

  const [isUploading, setIsUploading] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: isSuccessOpen, onOpen: onSuccessOpen, onClose: onSuccessClose } = useDisclosure();
  const { isOpen: isCancelSuccessOpen, onOpen: onCancelSuccessOpen, onClose: onCancelSuccessClose } = useDisclosure();
  const [file, setFile] = useState();

  const [deposit, { isLoading, data: depositData, isError, isSuccess, error }] = useDepositFundsMutation();

  const [
    cancelDeposit,
    {
      isLoading: isCancelling,
      data: cancelData,
      isError: isCancelError,
      isSuccess: isCancelSuccess,
      error: cancelError,
    },
  ] = useCancelFundDepositMutation();

  const handleSuccessModalClose = () => {
    onSuccessClose();
    history?.push("/dashboard/wallet");
  };

  const handleCancelModalClose = () => {
    onCancelSuccessClose();
    ls.remove(depositKey);
    setDepositData(null);
    history?.push(`/dashboard/wallet/fund/${coin}`, { replace: true });
  };

  const handleCancel = () => {
    cancelDeposit(data?._id);
    setState({ method: data?.depositPaymentType });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    onClose();
    let location = null;
    const id = data?._id;

    // console.log("ID", {
    //   id,
    //   file,
    //   user: `naira-deposit-${id}-user-${props?.userData?.userId}`,
    // });
    try {
      setIsUploading(true);
      const res = await uploadFile(file, `${coin}-deposit-${id}-user-${data?.userDetails?.userId}`);
      location = res?.location;
      console.log(location);
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      console.log("DEPOSIT UPLOAD FILE ERROR", error);
      toast({
        position: "bottom-right",
        title: "Oops!!",
        description: error?.message ?? "An unexpected error occurred",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
    location && deposit({ id, paymentUploadUrl: location });
  };

  useEffect(() => {
    if (isSuccess && depositData) {
      console.log("SUCCESS DEPOSIT DATA", depositData);
      ls.remove(depositKey);
      onSuccessOpen();
    }
    if (isError && error) {
      toast({
        position: "bottom-right",
        title: "Oops!!",
        description: getError(error?.data?.error),
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  }, [isError, error, toast, isSuccess, depositData, onSuccessOpen]);

  useEffect(() => {
    if (isCancelSuccess && cancelData) {
      console.log("CANCEL DEPOSIT DATA", cancelData);

      onCancelSuccessOpen();
    }
    if (isCancelError && cancelError) {
      toast({
        position: "bottom-right",
        title: "Oops!!",
        description: getError(cancelError?.data?.error),
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  }, [isCancelError, cancelError, toast, isCancelSuccess, cancelData, onCancelSuccessOpen]);

  return (
    <>
      {!data && (
        <Box alignItems="flex-start" w="100%" mb="20px !important">
          <Text fontSize="xs" color="gray.500">
            Transaction fee: <strong>{formatter(coin).format(fee)}</strong>
          </Text>
          <Text fontSize="xs" color={isLowerThanMinimum ? "red.400" : "gray.500"}>
            Mnimum deposit: <strong>{formatter(coin).format(min)}</strong>
          </Text>
        </Box>
      )}

      {data && (
        <VStack as="form" onSubmit={handleSubmit}>
          <FormControl>
            <Input
              disabled={true}
              type="number"
              label="Deposit Amount"
              defaultValue={data?.amount?.$numberDecimal}
              onChange={undefined}
              startAdornment={currencySymbol(coin)}
              //   endAdornment="USD"
            />
          </FormControl>

          <Box w="100%" borderRadius="20px" border="1px solid #EFF0F6">
            <HStack p="20px 28px" borderBottom="1px solid #EAEAEA5f">
              {/* <Avatar src={FCMB} /> */}
              <Text ml="12px !important">{data?.depositBankTo?.bankName}</Text>
            </HStack>

            <HStack w="100%" borderBottom="1px solid #EAEAEA5f">
              <Box flex="1" minH="77px" p="20px 28px">
                <Text fontSize="xs" color="#4E4B66">
                  Account Name
                </Text>
                <Text fontSize="sm" color="#14142B" fontWeight="500">
                  {data?.depositBankTo?.bankAccountName}
                </Text>
              </Box>
              <Divider height="100%" orientation="vertical" />
              <Box flex="1" minH="77px" p="20px 28px" borderLeft="1px solid #EAEAEA5f" ml="0px !important">
                <Text fontSize="xs" color="#4E4B66">
                  Account Number
                </Text>
                <HStack>
                  <Text fontSize="sm" color="#14142B" fontWeight="500">
                    {data?.depositBankTo?.bankAccountNumber}
                  </Text>
                  <IconButton
                    aria-label="copy button"
                    size="xs"
                    bg="transparent"
                    _hover={{ bg: "transparent" }}
                    _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                    icon={<Box color="#6E7191" as={CopyIcon} />}
                    onClick={onCopy}
                  />
                </HStack>
              </Box>
            </HStack>

            <HStack w="100%">
              <Box flex="1" minH="77px" p="20px 28px">
                <Text fontSize="xs" color="#4E4B66">
                  Transaction Reference
                </Text>
                <HStack>
                  <Text fontSize="sm" color="#14142B" fontWeight="500">
                    {data?.reference}
                  </Text>
                  <IconButton
                    aria-label="copy button"
                    size="xs"
                    bg="transparent"
                    _hover={{ bg: "transparent" }}
                    _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                    icon={<Box color="#6E7191" as={CopyIcon} />}
                    onClick={onTxRefCopy}
                  />
                </HStack>
              </Box>
              <Divider height="100%" orientation="vertical" />
              <Box flex="1" minH="77px" p="20px 28px" borderLeft="1px solid #EAEAEA5f" ml="0px !important">
                <Text fontSize="xs" color="#4E4B66" visibility={data?.depositBankTo?.branchName ? "visible" : "hidden"}>
                  Branch
                </Text>
                <Text
                  fontSize="sm"
                  color="#14142B"
                  fontWeight="500"
                  visibility={data?.depositBankTo?.branchName ? "visible" : "hidden"}
                >
                  {data?.depositBankTo?.branchName}
                </Text>
              </Box>
            </HStack>
          </Box>

          <Box p="14px" bg="#EFF0F6" borderRadius="8px">
            <Text fontSize="sm" color="red.400">
              <strong>Note:</strong> Payment must include the specified transaction reference and paid to the account
              specified above. Failure to do this may result in extended processing time. Do not add any crypto related
              details.
            </Text>
          </Box>

          <HStack mt="28px !important">
            <Button
              minH="64px"
              // maxW="384px"
              width="100%"
              fontWeight="normal"
              //   type="submit"
              style={{
                backgroundColor: "#fff",
                border: "1px solid #03a438",
                color: "#000",
              }}
              isLoading={isCancelling}
              onClick={handleCancel}
              disabled={isLoading || isCancelling}
            >
              Cancel
            </Button>

            <Button
              minH="64px"
              maxW="384px"
              width="100%"
              name="submitButton"
              fontWeight="normal"
              //   type="submit"
              onClick={onOpen}
              // onClick={this.handleSubmit}
              //   onClick={this.props?.onOpen}
              isLoading={isUploading || isLoading}
              disabled={isUploading || isLoading}
            >
              Send
            </Button>
          </HStack>
        </VStack>
      )}

      <UploadProof
        isOpen={isOpen}
        onClose={onClose}
        file={file}
        onFileChange={setFile}
        disableSkip
        onConfirm={handleSubmit}
        // isLoading={isUploading}
      />

      <SuccessModal
        isOpen={isSuccessOpen}
        onClose={handleSuccessModalClose}
        title={`${Number(data?.amount?.$numberDecimal).toLocaleString()} ${toCoinLocale(coin)}`}
        message="Your deposit will be processed and your wallet will be funded
                  soon."
      />
      <SuccessModal
        isOpen={isCancelSuccessOpen}
        onClose={handleCancelModalClose}
        title={`${Number(data?.amount?.$numberDecimal).toLocaleString()} ${toCoinLocale(coin)}`}
        message="Your deposit has been successfully cancelled"
      />
    </>
  );
};

const BankCard = () => {
  return (
    <Box>
      <FormControl>
        <NumberInput placeholder="Card Number" />
      </FormControl>
      <HStack mt="10px">
        <FormControl flex="2">
          <Input name="mmyy" placeholder="MM/YY" />
        </FormControl>
        <FormControl flex="1">
          <NumberInput name="cvv" placeholder="CVV" />
        </FormControl>
      </HStack>
    </Box>
  );
};

// eslint-disable-next-line
const MobileMoney = () => {
  return (
    <Box>
      <FormControl>
        <NumberInput placeholder="Card Number" />
      </FormControl>
      <HStack mt="10px">
        <FormControl flex="2">
          <Input name="mmyy" placeholder="MM/YY" />
        </FormControl>
        <FormControl flex="1">
          <NumberInput name="cvv" placeholder="CVV" />
        </FormControl>
      </HStack>
    </Box>
  );
};

const FlutterWave = (props) => {
  const { currency, user, min } = props;
  const checkout = useRef(window?.FlutterwaveCheckout);

  const toast = useToast();
  const [state, _setState] = useState({});

  // console.log("USER", user);

  const scriptUrl = "https://checkout.flutterwave.com/v3.js";

  const setState = (newState) => _setState(() => ({ ...state, ...newState }));

  const [fundWallet, { isLoading, isError, error }] = useFundFiatWalletMutation();

  const [processPayment, { isLoading: isProcessing }] = useProcessPaymentMutation();

  const makePayment = (payload) => {
    if (checkout?.current) {
      const pay = checkout.current;
      // console.log("checkout", pay);
      pay(payload);
    } else throw new Error("Failed to launch checkout action");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log("Called the script");
    await appendScriptPromise(scriptUrl);
    checkout.current = window?.FlutterwaveCheckout;

    // console.log("checkout", checkout);

    const obj = {
      currency: currency ?? "ghs",
      amount: state?.amount,
      depositType: "flutterwave",
    };

    const depositData = (await fundWallet(obj))?.data?.deposit;
    // const userData = depositData?.userDetails;

    // console.log("FLUTTER DEPOSIT DATA", obj, depositData, constants.FLUTTERWAVE_PUBKEY);

    depositData &&
      makePayment({
        public_key: constants.FLUTTERWAVE_PUBKEY,
        tx_ref: depositData?.reference,
        amount: Number(depositData?.amount["$numberDecimal"]),
        currency: String(depositData?.currency).toUpperCase(),
        country: countryMap(depositData?.currency),
        payment_options: "card, ussd",
        customer: {
          email: user?.email,
          phone_number: user?.phone,
          name: `${user?.fullName}`,
        },
        onclose: (incomplete) => {
          console.log("YOU JUST CANCELLED THE FLUTTERWAVE INLINE PAYMENT", incomplete);
        },
        callback: async function (data) {
          // specified callback function
          if (data?.status === "successful") {
            try {
              // attempt to fast track receipt, incase webhook failed
              if (data?.transaction_id) processPayment({ txId: data.transaction_id });
              else if (data.id) processPayment({ txId: data.id });
              console.log("posted flutterwave payment processing", data);
            } catch (err) {
              console.log("error posting flutterwave payment processing");
            }

            await new Promise((resolve) => {
              setTimeout(() => resolve(true), 1000);
            });
            removeScript(scriptUrl);
            window.location.replace(window.location.origin + `/dashboard/wallet/${currency}`);
          } else {
            if (2 + 2 === 4) return; //TODO: debug the setState
          }
        },
        customizations: {
          title: `Funds Deposit`,
          description: `Deposit of ${String(depositData?.currency).toUpperCase()}${Number(
            depositData?.amount["$numberDecimal"]
          )}`,
          logo: "https://prod-doc.fra1.cdn.digitaloceanspaces.com/btm-assets/logo.png",
        },
      });
  };

  const isLowerThanMinimum = useMemo(() => state?.amount && state?.amount < min, [state?.amount, min]);

  const isDisabled = useMemo(
    () => !state?.amount || isLoading || isProcessing || isLowerThanMinimum,
    [state, isLoading, isLowerThanMinimum, isProcessing]
  );

  useEffect(() => {
    (async () => {
      await appendScriptPromise(scriptUrl);
      checkout.current = window?.FlutterwaveCheckout;

      const status = window?.location?.pathname?.substring(31);
      setState({ status });

      // console.log("Checkout", checkout, window?.FlutterwaveCheckout);
    })();

    return () => {
      removeScript(scriptUrl);
    };

    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isError && error) {
      toast({
        position: "bottom-right",
        title: "Error",
        description: getError(error?.data?.error),
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  }, [error, isError, toast]);

  return (
    <>
      <FormControl>
        <Input
          label="Amount"
          value={state?.amount ?? ""}
          onChange={(e) => setState({ amount: e.target.value })}
          startAdornment={currencySymbol(currency)}
        />

        <FormHelperText>
          Minimum funding amount: {currencySymbol(currency)} {min}
        </FormHelperText>
      </FormControl>

      <Button
        isLoading={isLoading || isProcessing}
        disabled={isDisabled}
        w="100%"
        minH="64px"
        mt="72px !important"
        type="submit"
        onClick={handleSubmit}
      >
        Submit
      </Button>
    </>
  );
};

let count = 0;

const FundFiatWallet = (props) => {
  const currentPage = "Wallet";
  const { coin } = useParams();

  //   const { fiats, isLoading } = useWallet();

  const { isOpen: isConfirmOpen, onOpen: onConfirmOpen, onClose: onConfirmClose } = useDisclosure();

  const fundOptions = useMemo(() => {
    const map = {
      ngn: [{ name: "Bank Transfer", value: "bank" }],
      ghs: [
        // { name: "Bank Card", value: "bank_card" },
        { name: "Flutter Wave", value: "flutterwave" },
        { name: "Mobile Money", value: "momo" },
      ],
      kes: [
        // { name: "Bank Card", value: "bank_card" },
        { name: "Flutter Wave", value: "flutterwave" },
        { name: "Mobile Money", value: "momo" },
      ],
    };

    return map[coin ?? "ngn"];
  }, [coin]);

  const defaultOption = useMemo(() => {
    const map = {
      ngn: "bank",
      ghs: "flutterwave",
      kes: "flutterwave",
    };

    return map[coin ?? "ngn"];
  }, [coin]);

  const toast = useToast();
  const [depositData, setDepositData] = useState(null);
  const [state, setState] = useState({ method: defaultOption });

  // pass in momo, flutterwave, mpesa, or bank as method;
  const { data: depoConfig } = useGetDepositConfigQuery(state?.method);

  // console.log({ depoConfig });

  const [fundWallet, { data, isLoading, error, isError, isSuccess, reset }] = useFundFiatWalletMutation();

  //   const depositData = useMemo(() => {
  //     const depo = ls.get(depositKey) ?? {};
  //     console.log("STORED DEPO", depo);
  //     return data ?? depo;
  //     // eslint-disable-next-line
  //   }, [data]);

  const isDepoDataSet = useRef(false);

  console.log({ isDepoDataSet, depositData, hasDepo: !!depositData });

  useEffect(() => {
    const depo = ls.get(depositKey) ?? null;
    const hasDepo = String(depo).length > 0;

    if (!!data?.deposit && !isDepoDataSet.current) {
      setDepositData(data?.deposit);
      isDepoDataSet.current = true;
    } else if (!depositData && !isDepoDataSet.current && hasDepo) {
      count++;
      setDepositData(depo);
      setState({ ...state, method: data?.deposit?.depositPaymentType });
      isDepoDataSet.current = true;
    }

    return () => {
      reset();
      isDepoDataSet.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.deposit, depositData, isDepoDataSet, setState]);

  console.log("COUNT = ", count);

  const fee = useMemo(() => depoConfig?.fees[coin ?? "ghs"], [coin, depoConfig]);
  const min = useMemo(() => depoConfig?.mins[coin ?? "ghs"], [coin, depoConfig]);
  const max = useMemo(() => depoConfig?.maxs[coin ?? "ghs"], [coin, depoConfig]);

  //   const history = useHistory();

  const { label } = useCoinInfo(coin);

  // console.log("FIATS", fiats);

  const renderOption = () => {
    const map = {
      bank: (
        <BankTransfer
          coin={coin}
          isLowerThanMinimum={isLowerThanMinimum}
          data={data?.deposit ?? depositData}
          setDepositData={setDepositData}
          {...{ fee, min, max, setState: handleState }}
        />
      ),
      bank_card: <BankCard {...{ fee, min, max }} />,
      momo: (
        <BankTransfer
          coin={coin}
          isLowerThanMinimum={isLowerThanMinimum}
          data={data?.deposit ?? depositData}
          setDepositData={setDepositData}
          {...{ fee, min, max, setState: handleState }}
        />
      ),
      flutterwave: <FlutterWave currency={coin} user={props?.userData} {...{ fee, min, max }} />,
    };

    console.log("Method", state?.method);

    return map[state?.method ?? "bank"];
  };

  const handleState = (newState) => {
    setState({ ...state, ...newState });
  };

  const handleConfirm = () => {
    onConfirmClose();
    const reqData = {
      currency: coin,
      amount: +state?.amount + +fee,
      depositType: state?.method === "momo" ? "momo" : "bank",
    };

    fundWallet(reqData);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    onConfirmOpen();
  };

  useEffect(() => {
    if (isSuccess && data) {
      //   onSuccessOpen();
      console.log("Success", data);
      ls.set(depositKey, data?.deposit);
    }

    if (isError && error) {
      toast({
        position: "bottom-right",
        title: "Error",
        description: getError(error?.data?.error),
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  }, [isSuccess, error, data, isError, toast]);

  // useEffect(() => {
  //   if (defaultOption) handleState({ method: defaultOption });

  //   // eslint-disable-next-line
  // }, [defaultOption]);

  const isLowerThanMinimum = useMemo(() => state?.amount && state?.amount < min, [state?.amount, min]);

  const isDisabled = useMemo(
    () => !(state?.method && state?.amount) || isLoading || isLowerThanMinimum,
    [state, isLoading, isLowerThanMinimum]
  );

  return (
    <Box>
      <Sidemenu currentPage={currentPage} logoutUser={props.logout} />
      <Header />

      <Box className="wallet">
        <Box className="page-container" p={["6em 0 !important", "6.5em 1.5em !important"]}>
          <Container maxW="container.xl">
            <Box w="100%">
              <Box px={["24px", "0", "0"]}>
                <Heading fontSize="3xl">Fund Wallet</Heading>
                <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
                  <BreadcrumbItem>
                    <BreadcrumbLink to="/dashboard/wallet">Wallet</BreadcrumbLink>
                  </BreadcrumbItem>

                  <BreadcrumbItem>
                    <BreadcrumbLink to={`/dashboard/wallet/${coin}`}>{label} Wallet</BreadcrumbLink>
                  </BreadcrumbItem>

                  <BreadcrumbItem isCurrentPage>
                    <BreadcrumbLink isCurrentPage href="#">
                      Fund
                    </BreadcrumbLink>
                  </BreadcrumbItem>
                </Breadcrumb>
              </Box>

              <Box
                bg="white"
                border="1px solid #8688942f"
                // minH="681px"
                w={["100%", "100%", "calc(100% - 25vw)"]}
                //   w="fit-content"
                mt="32px"
                borderRadius="8px"
                p="48px 28px"
              >
                <VStack as="form" maxW="sm" m="0 auto">
                  {!depositData && (
                    <FormControl mt="20px !important">
                      <Select
                        isRequired
                        label="Fund Via"
                        //   isInvalid={data}
                        disabled={data}
                        // placeholder="Select Method"
                        value={state?.method ?? ""}
                        onChange={(e) => handleState({ method: e.target.value })}
                      >
                        {fundOptions.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.name}
                          </option>
                        ))}
                      </Select>
                    </FormControl>
                  )}

                  {["bank", "momo"].includes(state?.method) && !depositData && (
                    <FormControl>
                      <Input
                        isRequired
                        isInvalid={isLowerThanMinimum}
                        type="number"
                        label="Amount"
                        value={state?.amount ?? ""}
                        onChange={(e) => handleState({ amount: e.target.value })}
                        startAdornment={currencySymbol(coin)}
                        //   endAdornment="USD"
                      />
                    </FormControl>
                  )}

                  {/* {state?.wallet && (
                    <FormControl>
                      <HStack fontSize="sm">
                        <Text>Available balance: </Text>
                        <Text
                          color={
                            !isInsufficientBalance
                              ? "var(--primary)"
                              : "red.400"
                          }
                        >
                          {toPrecision(
                            getBalance(state?.wallet),
                            state?.wallet
                          )}
                        </Text>
                      </HStack>
                    </FormControl>
                  )} */}

                  {(state?.method ?? !!depositData) && renderOption()}

                  {["bank", "momo"].includes(state?.method) && !depositData && (
                    <Button
                      isLoading={isLoading}
                      disabled={isDisabled}
                      w="100%"
                      minH="64px"
                      mt="72px !important"
                      // type="submit"
                      onClick={handleSubmit}
                    >
                      Submit
                    </Button>
                  )}
                </VStack>
              </Box>
            </Box>
          </Container>
        </Box>
      </Box>

      <ConfirmationModal
        isOpen={isConfirmOpen}
        onClose={onConfirmClose}
        title="Confirm Deposit"
        onConfirm={handleConfirm}
      >
        <Text>3rd party payments will not be approved and cannot be refunded.</Text>
      </ConfirmationModal>
    </Box>
  );
};

export default FundFiatWallet;
